export enum RecordStatus {
    NORECORD = 'NORECORD',
    NEW = 'NEW',
    CHANGED = 'CHANGED',
    DISPLAY = 'DISPLAY',
}
